export const isInstrucaoSimples = (instrucao) => {
  if (!instrucao) return true;
  const instrucaoFormatada = instrucao
    .split("DOCUMENTO DE REFERÊNCIA")[0]
    .trim()
    .toLowerCase()
    .replace(/^-\s*/, "");

  return (
    instrucaoFormatada === "jejum não obrigatório." ||
    instrucaoFormatada === "jejum não obrigatório" ||
    instrucaoFormatada === "jejum nao obrigatorio." ||
    instrucaoFormatada === "jejum nao obrigatorio" ||
    instrucaoFormatada === "não é necessário jejum." ||
    instrucaoFormatada === "não é necessário jejum" ||
    instrucaoFormatada === "nao e necessario jejum." ||
    instrucaoFormatada === "nao e necessario jejum"
  );
};
